import { render } from "./DashboardTacticalWidgets.vue?vue&type=template&id=a4ef5bce"
import script from "./DashboardTacticalWidgets.vue?vue&type=script&lang=js"
export * from "./DashboardTacticalWidgets.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__